<template>
  <div id="app" class="container page">
    <div v-if="!['Cue', 'Focus', 'Probe', 'Outcome'].includes(this.$router.currentRoute.name)">
      <h1>TOPX</h1>
    </div>
    <router-view />
  </div>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import { mapActions } from 'vuex'
import queryString from 'querystringify'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'


Vue.use(BootstrapVue)
export default Vue.extend({
  mounted() {
    // parse out the url params
    const params = queryString.parse(location.search)

    // Generate a UUID using crypto.randomUUID() and
    // set the run_id to UUID if the params.key includes 'ketamine'
    const uniqueId = crypto.randomUUID();
    if (params.key && params.key.includes('ketamine')) {
      params.run_id = uniqueId;
    }

    // initialize the task and save the run_id, token, and return_to params
    this.init({
      runId: params.run_id,
      token: params.token,
      returnTo: params.return_to,
      task: params.task,
      workerId: params.worker_id,
      key: params.key ? params.key : 'topx',
    })

    console.log(`in mounted app runId: ${params.run_id}, token: ${params.token}, returnTo: ${params.return_to}, task: ${params.task}, workerId: ${params.worker_id}, key: ${params.key}`)

    Sentry.init({
      dsn: "https://67a82f24746c43d2ab010d6803f72d3d@o59337.ingest.sentry.io/4504401876418560",
      integrations: [new BrowserTracing()],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.1,
    })
    Sentry.setUser({ username: params.run_id });
    Sentry.setTag("task", "topx")
    // go to the initial state
    this.$router.replace('/')
  },
  methods: { ...mapActions(['init']) }
})
</script>

<style>
.page {
  background-color: rgba(128, 128, 128);
}

.centerOutcome {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -170%);
  width: 50vw;
}

.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.centerLeft {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-125%, -50%);
}

.centerRight {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(25%, -50%);
}

.centerbox-old {
  background-color: rgba(128, 128, 128);
  width: 50vw;
  height: 60vh;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}

.centerbox {
  width: 50vw;
  margin: auto;
  margin-top: 270px;
  font-size: 3em;
}

.leftbox {
  background-color: rgba(128, 128, 128);
  width: 50vw;
  height: 60vh;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-85%, -50%);
}

.rightbox {
  background-color: rgba(128, 128, 128);
  width: 50vw;
  height: 60vh;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-15%, -50%);
}

.blockText {
  width: 100%;
  height: 100vw;
  text-align: justify;
  margin: 0 auto;
  margin-bottom: 1em;
  font-size: 24px;
  line-height: 120%;
}

.centerBlockText {
  width: 100%;
  height: 100vw;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 1em;
  font-size: 26px;
  line-height: 120%;
}

.centerText {
  text-align: center;
  font-size: 60px;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.fixation {
  text-align: center;
  font-size: 150px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}

.imgContainer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
